import { AppBar, Box, Stack } from '@mui/material'
import Image from 'next/image'
import { ReactNode } from 'react'
import { UserDetails } from './headers/UserDetails'

export const MobileOverlay = ({ children }: { children?: ReactNode }) => {
  return (
    <Stack
      sx={{
        width: '100%',
        height: '100vh',
        position: 'fixed',
        top: 0,
        left: 0,
        backgroundColor: 'bg.surface.subtle',
        zIndex: 9998,
      }}
    >
      <AppBar
        position="static"
        sx={{
          backgroundColor: 'sidebar.text',
          borderBottomColor: '#373737',
          padding: 0,
          paddingLeft: '30px',
        }}
      >
        <Stack direction="row" justifyContent="space-between" sx={{ width: '100%' }} alignItems="center" spacing={6}>
          <Box alignContent="center">
            <Image src="/logo.svg" alt="Omnea logo" height={24} width={123} />
          </Box>
          <UserDetails view="minimal" />
        </Stack>
      </AppBar>
      {children}
    </Stack>
  )
}
